/* eslint-disable react/no-array-index-key */
import React, { useEffect, useState } from 'react';
import {
  Button, Card, Col, Row,
} from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';

import { createSurvey } from '../../../../bridge';
import { __ } from '../../../../helpers/translations';
import { categorizedServices } from '../../landing/Services';

function SelectTemplateModal() {
  const navigate = useNavigate();
  const [templateInfoArray, setTemplateInfoArray] = useState([]);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [target, setTarget] = useState(null);

  const onClickTarget = (newTarget) => {
    if (newTarget !== target) {
      setSelectedTemplate(null);
    }
    setTarget(newTarget);
  };

  const onClickTemplate = (template) => {
    setSelectedTemplate(template);
  };

  const onSelected = async (template) => {
    const { response } = await createSurvey({ templateId: template.id, self: template.self });
    if (template.self) {
      navigate(`/respondent/${response}/0`);
    } else {
      navigate(`/survey/${response}`);
    }
  };

  useEffect(() => {
    if (target) {
      setTemplateInfoArray(
        categorizedServices
          .filter((entry) => entry.heading === target)
          .map((entry) => entry.surveys)
          .flat()
          .filter((entry) => !entry.hidden),
      );
    } else {
      setTemplateInfoArray([]);
    }
  }, [target]);

  const getTemplateDisplay = (template) => (
    <>
      <Row>
        <div className="text-center">
          {template.image && (
            <img src={template.image} alt={template.title} />
          )}
          <h4 className="mt-4 mb-3">{template.title}</h4>
          {template.type
          && <h6>{template.type.toUpperCase()}</h6>}
        </div>
        {template.description && (
        <p className="mt-4">{template.description}</p>
        )}
      </Row>
      <Row className="justify-content-center py-4">
        <Col className="px-0">
          {!template.self
          && (
          <Link to={`/template/${template.id}/0`} target="_blank">
            <Button className="btn btn-light">{__('G38')}</Button>
          </Link>
          )}
        </Col>
        <Col className="px-0 justify-content-center" style={{ display: 'contents' }}>
          {!template.self
          && (
          <Link to={`/report/${template.id}/template`} target="_blank">
            <Button className="btn btn-light">{__('G39')}</Button>
          </Link>
          )}
        </Col>
        <Col className="px-0">
          <Button
            onClick={() => onSelected(template)}
            className="btn btn-primary float-end"
          >
            {template.self ? __('G304') : __('G56')}
          </Button>
        </Col>
      </Row>
    </>
  );

  return (
    <Card>
      <Row className="justify-content-center p-4">
        <Col lg={5}>
          <Card.Header className="fs-2 fw-bold pb-0">
            {__('G282')}
          </Card.Header>
          <Card.Body>
            {categorizedServices.map((entry, index) => (
              <div
                key={`template-group-${index}`}
                className="d-flex align-items-center mb-3"
                onClick={() => onClickTarget(entry.heading)}
                role="button"
                tabIndex={0}
              >
                <div className="fs-1">
                  {entry.heading}
                </div>
              </div>
            ))}
          </Card.Body>
          {templateInfoArray.length > 0 && (
            <>
              <Card.Header className="fs-2 fw-bold py-0">
                {__('G283')}
              </Card.Header>

              <Card.Body>
                {templateInfoArray.map((template) => (
                  <div
                    key={`template-${template.id}`}
                    className="d-flex align-items-center mb-4"
                    onClick={() => onClickTemplate(template)}
                    role="button"
                    tabIndex={0}
                  >
                    <div className="mr-3">
                      <img src={template.image} alt={template.title} className="me-3" width="50px" />
                    </div>
                    <div>
                      <div className="fs-1">{template.title}</div>
                    </div>
                  </div>
                ))}
              </Card.Body>
            </>
          )}
        </Col>
        <Col lg={7} className="p-4">
          {selectedTemplate && (
            getTemplateDisplay(selectedTemplate)
          )}
          {selectedTemplate?.alternate && (
            getTemplateDisplay(selectedTemplate.alternate)
          )}
        </Col>
      </Row>
    </Card>
  );
}

export default SelectTemplateModal;
